export default "__VITE_ASSET__ECyoxXYB__"